import React, { useEffect, useRef, useState } from "react";
import TestimonialElement from "../TestimonialElement/TestimonialElement";
import "./TestimonialGrid.css";
import axios from "axios";
import SectionTitle from "../../../../components/SectionTitle/SectionTitle";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import { Pagination, Stack } from "@mantine/core";

const paginatedTestimonial = (testimonials, _page, _pageSize) => {
    if (!testimonials) return
    //APPLY PAGINATION
    const startIndex = (_page - 1) * _pageSize;
    const endIndex = startIndex + _pageSize;

    return testimonials.slice(startIndex, endIndex);
};

const TestimonialGrid = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [isAnimated, setIsAnimated] = useState(false)
    const { width } = useWindowDimensions();
    const isMobile = width <= 768;
    const [page, setPage] = useState(1)


    const fetchTestimonials = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_SERVER}/info/testimonies`
            );
            console.log(response.data)
            const formattedResponse = response.data.map((testimonial) => {
                return {
                    name: `${testimonial.user?.name} ${testimonial.user?.lastname}`,
                    image: testimonial?.user?.profilePicture || testimonial.profilePicture,
                    text: testimonial.review,
                    id: testimonial._id,
                    academicUnit: {
                        name: testimonial?.academicUnit?.comercialInformation?.name,
                        type: testimonial?.academicUnit?.type
                    }
                };
            });
            setTestimonials(formattedResponse);
        } catch (error) {
            console.error("Error fetching testimonials data:", error);
        }
    };

    useEffect(() => {
        fetchTestimonials();
    }, []);

    const [currentItem, setCurrentItem] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const intervalRef = useRef(null);

    const PAGE_SIZE = 4
    const totalPages = Math.ceil(testimonials.length / PAGE_SIZE)
    const currentText = testimonials.find((item, idx) => currentItem === idx)

    const testimonialToShow = isMobile ? testimonials : paginatedTestimonial(testimonials, page, PAGE_SIZE)

    useEffect(() => {
        if (!isPaused) {

            intervalRef.current = setInterval(() => {
                setCurrentItem((prev) => (prev + 1) % testimonialToShow.length);

            }, 4500);
        }

        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [isPaused, testimonials.length]);

    useEffect(() => {
        if (!currentText) return;

        setIsAnimated(true);

        const timeout = setTimeout(() => {
            setIsAnimated(false);
        }, 500);

        return () => clearTimeout(timeout);
    }, [currentItem]);



    return (
        <div className="testimonialGrid-grid-wrapper">
            <SectionTitle upText="testimonios" downText="Nuestros Alumnos Dicen" />

            <div className="testimonialGrid-grid-container">
                <div
                    className="TestimonialElement-wrapper-container"
                    onMouseEnter={() => setIsPaused(true)}
                    onMouseLeave={() => setIsPaused(false)}
                >
                    {testimonialToShow.map((testimonial, idx) => (
                        <TestimonialElement
                            onClick={() => setCurrentItem(idx)}
                            is_active={idx === currentItem}
                            key={testimonial.id}
                            name={testimonial.name ? testimonial.name : "Unknown"}
                            image={testimonial.image}
                            text={testimonial.text ? testimonial.text : "No hay datos que mostrar"}
                        />
                    ))}
                    <div className="testimonialGrid-pagination">
                        <Pagination value={page} onChange={setPage} total={totalPages} />
                    </div>
                </div>
                <div
                    onMouseEnter={() => setIsPaused(true)}
                    onMouseLeave={() => setIsPaused(false)}
                    className={`testimonialElement-text-div ${isAnimated ? "testimonialElement-text-div--animated" : ""}`}>
                    <Stack
                        align="start"
                    >
                        <div>
                            <h4 style={{ fontSize: "var(--fs-h3)" }}>{currentText?.name}</h4>
                            <h5 style={{ fontWeight: '400' }}>Sobre <strong>{currentText?.academicUnit?.name}</strong></h5>
                        </div>
                        <blockquote>
                            {currentText?.text}
                        </blockquote>
                    </Stack>
                </div>
            </div>
        </div>
    );

};

export default TestimonialGrid;